


















































import { Vue, Component } from "vue-property-decorator"
import FormTag from "@/components/form-tag-list.vue"
import ConversionSidebar from "@/components/ConversionSidebar.vue"
import CreateRecipeBasicInfo from "@/components/CreateRecipeBasicInfo.vue"
import CreateRecipeProcedure from "@/components/CreateRecipeProcedure.vue"
import CreateRecipeIngredientsList from "@/components/CreateRecipeIngredientsList.vue"

@Component({
	components: {
		Vue,
		FormTag,
		ConversionSidebar,
		CreateRecipeBasicInfo,
		CreateRecipeProcedure,
		CreateRecipeIngredientsList
	}
})
export default class CreateRecipeForm extends Vue {
	troubleshoot = true
	recipe: RecipeObject = {
		name: "",
		teaser: "",
		image: "",
		ingredients: [
			{
				amount: "",
				unit: "",
				ingredient: "f.eks hvedemel"
			},
			{
				amount: "",
				unit: "",
				ingredient: "f.eks vand"
			},
			{
				amount: "",
				unit: "",
				ingredient: "f.eks salt"
			}
		],
		steps: ["", "", ""],
		path: "description", // default
		servings: "",
		servings_w_type: {
			servings: "",
			type: ""
		},
		preparationtime: {
			active: "",
			passive: ""
		},
		protip: "",
		categories: [],
		relatedrecipes: [],
		inspirationlink: ""
	}

	combinations: ConversionObject[] = [
		{
			from: "fahrenheit",
			to: "celsius"
		},
		{
			from: "cups",
			to: "deciliter"
		},
		{
			from: "ounces",
			to: "gram"
		}
	]

	addIngredient() {
		this.recipe.ingredients.push({
			amount: "",
			unit: "",
			ingredient: ""
		})
	}

	get mailingInfo(): MailToObject {
		return {
			email: "henriette.steenhoff@gmail.com",
			subject: encodeURI("Nyt forslag til opskrift: " + this.recipe.name),
			body: "Jeg har brugt din hjemmeside til at generere denne opskrift, som du gerne må tage et kig på: " + encodeURI(JSON.stringify(this.recipe))
		}
	}

	created() {
		this.$root.$on("delete-ingredient", this.deleteRow)
		this.$root.$on("delete-step", this.deleteStep)
		this.$root.$on("add-step", this.addStep)
		this.$root.$on("add-ingredient", this.addIngredient)
	}

	updated() {
		this.recipe.categories = this.$store.getters.getCreateTags
	}

	beforeDestroy() {
		this.$off("delete-ingredient")
		this.$off("delete-step")
		this.$off("add-step")
		this.$off("add-ingredient")
	}

	addStep() {
		this.recipe.steps.push("")
	}

	deleteStep(index: number) {
		this.recipe.steps.splice(index, 1)
	}

	deleteRow(index: number) {
		this.recipe.ingredients.splice(index, 1)
	}
}
